export default __webpack_public_path__ + "static/media/Order-List.a3a4a704.jpg";